/*
 * @Author: whb
 * @Date: 2023-01-10 18:59:18
 * @LastEditors: whb
 * @LastEditTime: 2023-01-12 19:25:35
 * @Description: 弹框
 */
import React, { useEffect, useState } from 'react';
import './index.scss';
const Mask = (props) => {
  const [scrollTop, setScrollTop] = useState(0);
  const className = 'modalOpen';
  const maskCk = (e) => {
    if (e.target.className.indexOf('mask') > -1) {
      console.log('props hide--', props.hide);
      props?.hide?.();
    }
  };
  useEffect(() => {
    if (props.display === 'none') {
      document.body.classList.remove(className);
      window.document.scrollingElement.scrollTop = scrollTop;
      window.document.body.scrollTop = scrollTop;
      window.document.documentElement.scrollTop = scrollTop;
    } else {
      setScrollTop(window.document.body.scrollTop || window.document.documentElement.scrollTop);
      document.body.classList.add(className);
      document.body.style.top = `-${scrollTop}px`;
    }
  }, [props.display, scrollTop]);
  return (
    <div style={{display: props.display}} className={['mask', props.class].join(' ')} onClick={maskCk}>
      {props.children}
    </div>
  )
};
export default Mask;